import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IResponseMasterBankData {
  responseCode: string,
  responseMessage: string,
}

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IGetMasterBankData {
  id: number,
  bank_code: string,
  bank_desc: string,
  bank_key: string,
  is_active: number,
}

export interface IGetMasterBankResponse {
  list_mst_bank: IGetMasterBankData[],
  metadata: MetadataI,
}

export interface GetMasterBankParamsI {
  page_number?: number,
  page_size?: number,
  search?: string
  sort_by?: string,
  sort_type?: string,
}

export interface IGetDetailMasterBankResponse {
  id: number,
  bank_code: string,
  bank_desc: string,
  bank_key: string,
  is_active: number,
  create_by: string,
  create_at: string,
  update_by: string,
  update_at: string
}

export const url = "/v1/smplmstbank";

export const postMasterBank = async (
  payload: any,
): Promise<IResponseMasterBankData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const getMasterBank = async (
  payload: GetMasterBankParamsI,
): Promise<IGetMasterBankResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getDetailMasterBank = async (
  id: string,
): Promise<IGetDetailMasterBankResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "GET",
  });

  return data;
};

export const deleteMasterBank = async (
  id: string | number,
): Promise<IResponseMasterBankData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "DELETE",
  });

  return data;
};
